import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SunLogo } from "./SunLogo";
import { BUSINESS_FR, SERVICES_FR, QC_CITIES } from "../data/site-fr";

export const FooterFr = () => (
  <footer data-testid="site-footer-fr" className="bg-[#0A0B0E] border-t border-white/10 pb-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <SunLogo size={34} />
            <span className="font-heading leading-tight">
              <span className="block font-bold text-white text-lg">1st Nations Security</span>
              <span className="block text-[10px] font-semibold uppercase tracking-widest text-[#FF9100]">Services de Sécurité</span>
            </span>
          </div>
          <p className="text-sm text-gray-400 leading-relaxed mb-5">
            Entreprise de gardiennage détenue et exploitée par des Autochtones, au service du Québec et du Manitoba avec des services professionnels de gardiennage, de patrouille et de réponse.
          </p>
          <ul className="space-y-2.5 text-sm">
            <li>
              <a href={BUSINESS_FR.phoneHref} data-testid="footer-fr-phone-link" className="flex items-center gap-2 text-gray-300 hover:text-[#FF9100] transition-colors">
                <Phone className="w-4 h-4 text-[#FF9100]" /> {BUSINESS_FR.phone}
              </a>
            </li>
            <li>
              <a href={BUSINESS_FR.emailHref} data-testid="footer-fr-email-link" className="flex items-center gap-2 text-gray-300 hover:text-[#FF9100] transition-colors">
                <Mail className="w-4 h-4 text-[#FF9100]" /> {BUSINESS_FR.email}
              </a>
            </li>
            <li className="flex items-center gap-2 text-gray-400">
              <MapPin className="w-4 h-4 text-[#FF9100]" /> Au service du Québec et du Manitoba
            </li>
            <li className="flex items-center gap-2 text-gray-400">
              <Clock className="w-4 h-4 text-[#FF9100]" /> Répartition 24/7, 365 jours par année
            </li>
          </ul>
        </div>

        <nav aria-label="Services de sécurité">
          <h3 className="text-xs font-semibold uppercase tracking-widest text-[#FF9100] mb-4">Services de Sécurité</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/francais/services-de-securite" data-testid="footer-fr-services-all" className="text-gray-300 font-semibold hover:text-[#FF9100] transition-colors">Tous les services</Link></li>
            {SERVICES_FR.map((s) => (
              <li key={s.slug}>
                <Link to={`/francais/services-de-securite/${s.slug}`} data-testid={`footer-fr-service-${s.slug}`} className="text-gray-400 hover:text-[#FF9100] transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Villes desservies au Québec">
          <h3 className="text-xs font-semibold uppercase tracking-widest text-[#FF9100] mb-4">Villes du Québec</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/francais/villes" data-testid="footer-fr-villes-all" className="text-gray-300 font-semibold hover:text-[#FF9100] transition-colors">Toutes les villes</Link></li>
            {QC_CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/francais/villes/${c.slug}`} data-testid={`footer-fr-ville-${c.slug}`} className="text-gray-400 hover:text-[#FF9100] transition-colors">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Entreprise">
          <h3 className="text-xs font-semibold uppercase tracking-widest text-[#FF9100] mb-4">Entreprise</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/francais/a-propos" data-testid="footer-fr-apropos" className="text-gray-400 hover:text-[#FF9100] transition-colors">À propos de nous</Link></li>
            <li><Link to="/francais/contact" data-testid="footer-fr-contact" className="text-gray-400 hover:text-[#FF9100] transition-colors">Nous joindre</Link></li>
            <li><Link to="/francais/a-propos" data-testid="footer-fr-about" className="text-gray-400 hover:text-[#FF9100] transition-colors">À propos</Link></li>
            <li><Link to="/" data-testid="footer-fr-en" className="text-gray-400 hover:text-[#FF9100] transition-colors">English Site</Link></li>
          </ul>
          <div className="mt-6 p-4 rounded-xl border border-[#FF9100]/25 bg-[#FF9100]/5">
            <p className="text-xs text-gray-300 leading-relaxed">
              Fournisseur de sécurité 100 % détenu par des Autochtones et dévoué aux communautés
            </p>
          </div>
        </nav>
      </div>

      <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-gray-500">© {new Date().getFullYear()} 1st Nations Security. Services de gardiennage au Québec et au Manitoba, Canada.</p>
        <p className="text-xs text-gray-600">Montréal · Laval · Québec · Gatineau · Winnipeg · Brandon</p>
      </div>
    </div>
  </footer>
);
